import { ExpertCheckActions, GlobalActions } from '@src/types/actions'
import { getType } from 'typesafe-actions'
import { resetState } from '../actions'
import {
  clearFeedbackContent,
  createTicket,
  createTicketFailure,
  createTicketSuccess,
  setFeedbackContent,
  setFeedbackDate,
  setNetworkError,
  setRedirectToSuccessFalse,
  setShouldSubmitAfterLogin,
  setShouldSubmitOnload,
} from './actions'
import { createFeedbackDate } from './utils'

interface FeedbackType {
  criterion: string
  content: string | null
  score: number | null
  omittedCharacterLength: number
}

export interface FeedbackContentType {
  feedbackInApp?: boolean
  feedbackAvailable?: boolean
  feedbackIsValid?: boolean
  feedbackIsPartial?: boolean
  feedbackNote?: string | null
  dueDate?: string
  feedback?: FeedbackType[]
}

export interface ExpertCheckState {
  isCreatingTicket: boolean
  redirectToSuccessPage: boolean
  ticketId?: string
  createTicketError?: boolean
  feedbackDate?: string
  feedbackContent?: FeedbackContentType
  shouldSubmitOnload?: boolean
  networkError?: boolean
  shouldSubmitAfterLogin?: boolean
}

const initialState: ExpertCheckState = {
  isCreatingTicket: false,
  redirectToSuccessPage: false,
  feedbackContent: {},
}

export default (
  state: ExpertCheckState = initialState,
  action: ExpertCheckActions | GlobalActions
) => {
  switch (action.type) {
    case getType(setFeedbackDate): {
      return {
        ...state,
        feedbackDate: createFeedbackDate(action.payload.turnAroundDays),
      }
    }
    case getType(setRedirectToSuccessFalse): {
      return {
        ...state,
        redirectToSuccessPage: false,
      }
    }
    case getType(createTicket): {
      return {
        ...state,
        isCreatingTicket: true,
        createTicketError: false,
      }
    }
    case getType(createTicketSuccess): {
      return {
        ...state,
        isCreatingTicket: false,
        ticketId: action.payload.ticketId,
        redirectToSuccessPage: true,
      }
    }
    case getType(createTicketFailure):
      return {
        ...state,
        isCreatingTicket: false,
        createTicketError: true,
      }
    case getType(resetState): {
      return initialState
    }
    case getType(setFeedbackContent): {
      return {
        ...state,
        feedbackContent: action.payload,
      }
    }
    case getType(clearFeedbackContent): {
      return {
        ...state,
        feedbackContent: {},
      }
    }
    case getType(setShouldSubmitOnload): {
      return {
        ...state,
        shouldSubmitOnload: action.payload.shouldSubmit,
      }
    }
    case getType(setNetworkError): {
      return {
        ...state,
        networkError: action.payload.networkError,
      }
    }
    case getType(setShouldSubmitAfterLogin): {
      return {
        ...state,
        shouldSubmitAfterLogin: action.payload.shouldSubmitAfterLogin,
      }
    }
    default:
      return state
  }
}



// WEBPACK FOOTER //
// ./src/state/expertcheck/reducer.ts